export const handleBooleanFilter = (filter: any) => {
  if (filter && filter?.includeValues?.includes("Yes")) return true;
  if (filter && filter?.includeValues?.includes("No")) return false;
  return null;
};
